import { Button } from '@/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/dropdown';
import { FormLabel } from '@/components/form/formlabel';
import { Input } from '@/components/form/input';
import {
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/form/select';
import { Modal } from '@/components/modal';
import { DataTable } from '@/components/table/datatable';
import { clearErrors } from '@/reducers/events';
import { AppDispatch } from '@/root/store';
import { GetSocialMedias, StoreSocialMedia } from '@/services/events';
import { NoSymbolIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import {
  ClipboardDocumentIcon,
  DocumentCheckIcon,
  EllipsisHorizontalIcon,
} from '@heroicons/react/24/solid';
import { Select } from '@radix-ui/react-select';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

interface SocialMedia {
  id: number;
  username: string;
  type: string;
  url: string;
}

export function OrgEventSocialMedia() {
  const location = useLocation();
  const { slug } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showDelete, setShowDelete] = useState({
    modal: false,
    id: 0,
  });
  const [formData, setFormData] = useState({ type: 'instagram', url: '' });

  const { socialMedias, paginator, errors } = useSelector(
    (state: any) => state.event
  );

  const { event } = useSelector((state: any) => state.event);

  const queryParams = new URLSearchParams(location.search);
  const searchQuery: string = queryParams.get('search') ?? '';

  useEffect(() => {
    dispatch(GetSocialMedias(slug, searchQuery, page));
  }, [searchQuery, page]);

  const setData = (value: string, element: string) => {
    setFormData({ ...formData, [element]: value });

    dispatch(clearErrors());
  };

  const submitSocialMedia = () => {
    dispatch(StoreSocialMedia(event.id, formData));
  };

  const deleteSocialMedia = (socialMediaId: number) => {
    //

    setShowDelete({ modal: false, id: 0 });
  };

  const ctaButton = (
    <Button
      onClick={() => {
        setShowModal(true);
      }}
      leftIcon={<PlusIcon />}
    >
      Tambah sosial media
    </Button>
  );

  const columns: ColumnDef<SocialMedia>[] = [
    {
      header: 'Username',
      cell: ({ row }) => {
        const username = row.original.username;
        const type = row.original.type;
        return (
          <div>
            <p>{username}</p>
            <span className='text-gray-500'>{type}</span>
          </div>
        );
      },
    },
    {
      header: 'Aksi',
      cell: ({ row }) => {
        return (
          <DropdownMenu>
            <DropdownMenuTrigger>
              <Button
                size='sm'
                variant='neutral'
                leftIcon={<EllipsisHorizontalIcon />}
              />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem
                onClick={() => window.open(row.original.url, '_blank')}
              >
                <ClipboardDocumentIcon className='mr-2 h-4 w-4' />
                <span>Buka</span>
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => {
                  setShowDelete({ modal: true, id: row.original.id });
                }}
              >
                <TrashIcon className='mr-2 h-4 w-4 text-danger' />
                <span className='text-danger'>Hapus</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        show={showModal}
        onRequestClose={() => setShowModal(false)}
        width='medium'
        title='Tambah Sosial Media'
        body={
          <div className='flex flex-col gap-4'>
            <div className='mb-3'>
              <FormLabel label='Tipe' errorText={errors.email} required>
                <Select onValueChange={(e) => setData(e, 'type')}>
                  <SelectTrigger>
                    <SelectValue defaultValue='instagram' />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value={'instagram'}>Instagram</SelectItem>
                      <SelectItem value={'tiktok'}>Tiktok</SelectItem>
                      <SelectItem value={'facebook'}>Facebook</SelectItem>
                      <SelectItem value={'youtube'}>Youtube</SelectItem>
                      <SelectItem value={'whatsapp'}>Whatsapp</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </FormLabel>
            </div>
            <div className='mb-3'>
              <FormLabel
                label={
                  !['whatsapp'].includes(formData.type)
                    ? 'Profil Url'
                    : 'No. Whatsapp'
                }
                errorText={errors.url}
                required
              >
                <Input
                  type='text'
                  placeholder={
                    !['whatsapp'].includes(formData.type)
                      ? `https://www.${formData.type}.com/namapengguna`
                      : ''
                  }
                  value={formData.url}
                  onChange={(e) => setData(e.target.value, 'url')}
                />
              </FormLabel>
            </div>
          </div>
        }
        footer={
          <div className='flex justify-end gap-3'>
            <Button
              variant='neutral'
              onClick={() => setShowModal(false)}
              leftIcon={<NoSymbolIcon />}
            >
              Batal
            </Button>
            <Button
              onClick={submitSocialMedia}
              leftIcon={<DocumentCheckIcon />}
            >
              Simpan
            </Button>
          </div>
        }
      />

      <Modal
        show={showDelete.modal}
        onRequestClose={() => setShowDelete({ ...showDelete, modal: false })}
        width='medium'
        title='Hapus Sosial Media'
        body={
          <>
            <p>Apakah kamu yakin ingin menghapus akun ini?</p>
          </>
        }
        footer={
          <div className='flex justify-end gap-3'>
            <Button
              variant='neutral'
              onClick={() => setShowDelete({ ...showDelete, modal: false })}
              leftIcon={<NoSymbolIcon />}
            >
              Batal
            </Button>
            <Button
              variant={'danger'}
              onClick={() => {
                deleteSocialMedia(showDelete.id);
              }}
              leftIcon={<TrashIcon />}
            >
              Ya, Hapus
            </Button>
          </div>
        }
      />

      <DataTable
        name='Daftar sosial media'
        noun={'sosial media'}
        ctaButton={
          !['finance', 'scanner'].includes(event?.logged_in_organizer?.role) ? (
            ctaButton
          ) : (
            <></>
          )
        }
        columns={columns}
        data={socialMedias}
        total={paginator.to}
        currentTotal={paginator.total}
        currentPage={paginator.current_page}
        pages={paginator.last_page}
        onPageRequest={(nextPage) => setPage(nextPage)}
      />
    </>
  );
}
